import type { FC } from 'react';
import ContentLoader from 'react-content-loader';
import { Fragment } from 'react';

export const ChatSkeleton: FC = () => (
  <ContentLoader
    backgroundColor="#eaeff5"
    className="ev-chat__skeleton"
    foregroundColor="#b8c3d1"
    viewBox="0 0 500 420"
  >
    {new Array(4).fill('').map((_item, itemIndex) => {
      const startY = itemIndex * 89;
      const avatarCenterX = itemIndex % 2 ? 456 : 44;
      const avatarCenterY = startY + 28;
      const bubbleStartX = itemIndex % 2 ? 180 : 80;
      const bubbleStartY = startY + 18;
      const bubbleCornerStartX = itemIndex % 2 ? 396 : bubbleStartX;

      return (
        <Fragment key={itemIndex}>
          <circle cx={avatarCenterX} cy={avatarCenterY} r="28" />
          <rect
            x={bubbleStartX}
            y={startY}
            rx="7"
            ry="7"
            width="240"
            height="14"
          />
          <rect
            x={bubbleCornerStartX}
            y={bubbleStartY}
            rx="0"
            ry="0"
            width="24"
            height="24"
          />
          <rect
            x={bubbleStartX}
            y={bubbleStartY}
            rx="24"
            ry="24"
            width="240"
            height="47"
          />
        </Fragment>
      );
    })}
  </ContentLoader>
);
